// 统一 Firebase 配置 - 从 utils 包导入
import { edgenFirebaseConfig, edgenVapidKeyConfig } from "utils";

// 导出统一配置
export const firebaseConfig = edgenFirebaseConfig;

// 导出统一 VAPID Key 配置
export const vapidKeyConfig = edgenVapidKeyConfig;
